import axios from 'axios'

function initialState() {
  return {
    uiConfigOptions: {
      data: [],
      isLoading: false,
    },
    fileExportNames: [],
  }
}

export const UiConfigKeys = {
  FileExportProjectName: 'FileExportProjectName',
  FileExportTenantName: 'FileExportTenantName',
  ReportComponentVisibility: 'ReportComponentVisibility',
  StationGraphTabGlobalVisibility: 'StationGraphTabGlobalVisibility',
  DashboardConfiguration: 'DashboardConfiguration',
  UseDashboardConfig: 'UseDashboardConfig',
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getUiConfigOptions({
      commit,
      state,
      rootGetters,
    }, options) {
      state.uiConfigOptions.isLoading = true
      try {
        let config = (options && options.config) || {}
        let forceParam = (options && options.forced) || false
        let currentRoleName = rootGetters['authenticate/currentUserGroup'] && rootGetters['authenticate/currentUserGroup'].name || ''
        let isCrossTenantRequest = (config.params && config.params.tenant && config.params.tenant != currentRoleName)
        let shouldForceUpdate = forceParam || isCrossTenantRequest || state.uiConfigOptions.data.length == 0

        let data = state.uiConfigOptions.data
        if (shouldForceUpdate) {
          let res = await axios.get('api/UiConfig/Options/List', config)
          if (!isCrossTenantRequest) {
            commit('SetUiConfigOptions', res.data)
          }
          data = res.data
        }
        options.successCb(data)
      } catch (err) {
        options.failedCb(err && err.response && err.response.data, err)
      } finally {
        state.uiConfigOptions.isLoading = false
      }
    },
    async getFileExportNames({
      commit,
    }) {
      let addKey = (url, key, delim = '&') => `${url}${delim}keys=${key}`

      let url = 'api/UiConfig/Options'
      url = addKey(url, UiConfigKeys.FileExportProjectName, '?')
      url = addKey(url, UiConfigKeys.FileExportTenantName)

      let transformData = (data) => {
        let output = {}
        for (var id in data) {
          let current = {}
          for (let {
              Key,
              Value,
            } of data[id]) {
            current[Key] = Value
          }
          output[id] = current
        }
        return output
      }

      axios.get(url)
        .then(response => commit('SetFileExportNames', transformData(response.data)))
        .catch(error => console.log(error))
    },
    async putUiConfigOptionArray({
      dispatch,
      rootGetters,
    }, options) {
      try {
        let config = options.config || {}
        let currentRoleName = rootGetters['authenticate/currentUserGroup'] && rootGetters['authenticate/currentUserGroup'].name || ''
        let isCrossTenantRequest = (config.params && config.params.tenant && config.params.tenant != currentRoleName)
        let res = await Promise.all(options.data.map(configOption =>
          axios.put('api/UiConfig/Option', configOption, config)
        ))
        if (!isCrossTenantRequest) {
          dispatch('getUiConfigOptions', {
            forced: true,
            successCb() {
              options.successCb(res)
            },
            failedCb(err) {
              options.failedCb(err.response, err)
            },
          })
        } else {
          options.successCb(res)
        }

      } catch (err) {
        options.failedCb(err.response, err)
      }
    },
  },
  mutations: {
    SetUiConfigOptions(state, data) {
      state.uiConfigOptions.data = data
    },
    SetUiConfigOptionArray(state, key, data) {
      state.uiConfigOptions.data[3] = data[0].data
    },
    SetFileExportNames(state, fileExportNames) {
      state.fileExportNames = fileExportNames
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    uiConfigOptions: state => state.uiConfigOptions,
    uiConfigOptionByKey: state => (key) => state.uiConfigOptions.data.find(x => x.Key === key),
    uiConfigIndex: (state) => {
      let index = {}
      state.uiConfigOptions.data.forEach(kv => {
        return index[kv.Key] = kv.Value
      })
      return index
    },
    fileExportNames: state => state.fileExportNames,
  },
}